import { motion } from 'framer-motion';
import { Delete } from 'lucide-react';

/**
 * The amount pad.
 *
 * Entry is right-to-left in minor units — tapping 1, 2, 5, 0 gives 12.50, not
 * 1250.00 — because that is how every till and card terminal a cashier has ever
 * used behaves, and a decimal point is one more thing to mis-tap during a queue.
 *
 * Keys are 64px tall. A counter is operated with a thumb, often in a hurry,
 * sometimes by someone holding a coffee.
 */
const KEYS = ['7', '8', '9', '4', '5', '6', '1', '2', '3', '0', '00'];

export function Keypad({ onDigit, onBackspace, onClear, disabled }) {
  const press = (label) => (label === '⌫' ? onBackspace() : onDigit(label));

  return (
    <div className="grid grid-cols-3 gap-2.5">
      {[...KEYS, '⌫'].map((label) => (
        <motion.button
          key={label}
          type="button"
          disabled={disabled}
          whileTap={disabled ? {} : { scale: 0.96 }}
          transition={{ duration: 0.09 }}
          onClick={() => press(label)}
          // Long-press to clear, so the pad needs no twelfth key competing for
          // space with the numbers.
          onContextMenu={(e) => { e.preventDefault(); onClear(); }}
          className="h-16 rounded-xl border bg-surface text-xl font-medium text-ink transition-colors hover:bg-surface-2 active:bg-surface-3 disabled:opacity-40"
          style={{ borderColor: 'rgb(var(--line))' }}
          aria-label={label === '⌫' ? 'Delete last digit' : label}
        >
          {label === '⌫' ? <Delete className="mx-auto h-5 w-5" aria-hidden="true" /> : label}
        </motion.button>
      ))}
    </div>
  );
}

export default Keypad;
